import { IMAGE_TYPES } from '@/constants/index.js';
import { bytes } from '@/utils/helpers.js';

export const MIN_NAME_LENGTH = 3;
export const MAX_NAME_LENGTH = 50;

export const IMAGE_LIB_FILE_TYPE = IMAGE_TYPES;
export const IMAGE_LIB_MAX_FILE_SIZE = bytes('10mb');

export const IMAGE_LIBRARY_BASE_FILTERS = {
    ALL: 'all',
    FAVOURITE: 'favourite',
    TEACHERS: 'teachers',
};

export const BASE_SIDEBAR_ITEMS = [
    {
        id: IMAGE_LIBRARY_BASE_FILTERS.ALL,
        name: 'Все файлы',
        icon: require('@/assets/svg/icon-upload-to-cloud.svg'),
    },
    {
        id: IMAGE_LIBRARY_BASE_FILTERS.FAVOURITE,
        name: 'Избранное',
        icon: require('@/assets/svg/icon-heart.svg'),
    },
    // todo: скрываем в MVP
    // {
    //     id: IMAGE_LIBRARY_BASE_FILTERS.TEACHERS,
    //     title: 'Преподаватели',
    //     icon: require('@/assets/svg/icons8-graduation-cap.svg'),
    // },
];

export const ImageLibSortTypes = {
    ALPHABETICAL_ASC: 'alphabetical_asc', // По имени (А-Я)
    ALPHABETICAL_DESC: 'alphabetical_desc', // По имени (Я-А)
    NEWEST: 'newest', // Сначала новые
    OLDEST: 'oldest', // Сначала старые
};

export const ImageLibSortParams = {
    [ImageLibSortTypes.ALPHABETICAL_ASC]: {
        sort_field: 'name',
        sort_direction: 'asc',
    },
    [ImageLibSortTypes.ALPHABETICAL_DESC]: {
        sort_field: 'name',
        sort_direction: 'desc',
    },
    [ImageLibSortTypes.NEWEST]: {
        sort_field: 'created_at',
        sort_direction: 'desc',
    },
    [ImageLibSortTypes.OLDEST]: {
        sort_field: 'created_at',
        sort_direction: 'asc',
    },
};

export const IMAGE_LIBRARY_SORT_DATA = [
    {
        label: 'По имени (А-Я)',
        value: ImageLibSortTypes.ALPHABETICAL_ASC,
    },
    {
        label: 'По имени (Я-А)',
        value: ImageLibSortTypes.ALPHABETICAL_DESC,
    },
    {
        label: 'Сначала новые',
        value: ImageLibSortTypes.NEWEST,
    },
    {
        label: 'Сначала старые',
        value: ImageLibSortTypes.OLDEST,
    },
];
